import type { ThemeDefinition } from "../theme-definition.type";

// Built from the logo: deep purple #662b83, light purple #aa62da, grey #494949.
export const saads: ThemeDefinition = {
  id: "saads",
  name: "Saads",
  light: {
    "background": "#f6f3f8",
    "foreground": "#1f1a24",
    "card": "#ffffff",
    "popover": "#ffffff",
    "muted": "#ebe6ef",
    "muted-foreground": "#494949",
    "border": "#ddd5e3",
    "input": "#8d8990",
    "primary": "#662b83",
    "primary-foreground": "#ffffff",
    "link": "#662b83",
    "accent": "#efe3f7",
    "accent-foreground": "#4a1d61",
    "brand": "#3c1053",
    "brand-foreground": "#ffffff",
    "ring": "#aa62da",
    "success": "#2f7a1c",
    "warning": "#8a5a00",
    "destructive": "#b22534",
    "info": "#2563a8",
  },
  dark: {
    "background": "#161418",
    "foreground": "#f1eef3",
    "card": "#201d24",
    "popover": "#2a2630",
    "muted": "#302c36",
    "muted-foreground": "#b5b0bb",
    "border": "#443e4c",
    "input": "#6e6b70",
    "primary": "#7a3c9d",
    "primary-foreground": "#ffffff",
    "link": "#c9a0ea",
    "accent": "#3a2548",
    "accent-foreground": "#efdcfa",
    "brand": "#3c1053",
    "brand-foreground": "#ffffff",
    "ring": "#aa62da",
    "success": "#7fc76f",
    "warning": "#e6b55d",
    "destructive": "#f4837c",
    "info": "#7db4e4",
  },
};

export const saadsGreen: ThemeDefinition = {
  id: "saads-green",
  name: "Saads Green",
  light: {
    "background": "#ffffff",
    "foreground": "#1a1a1a",
    "card": "#ffffff",
    "muted": "#f3ede1",
    "muted-foreground": "#5c5c5c",
    "border": "#e6e6e6",
    "input": "#919191",
    "primary": "#00803e",
    "primary-foreground": "#ffffff",
    "accent": "#e6f3ec",
    "accent-foreground": "#026634",
    "brand": "#12321a",
    "brand-foreground": "#ffffff",
    "ring": "#00803e",
    "success": "#2f7a1c",
    "warning": "#8a5a00",
    "destructive": "#b51213",
    "info": "#0077b9",
    "popover": "#ffffff",
    "link": "#007b3c",
  },
  dark: {
    "background": "#141715",
    "foreground": "#eff1ef",
    "card": "#1e211f",
    "popover": "#272c28",
    "muted": "#2d322e",
    "muted-foreground": "#adb3ae",
    "border": "#3e423f",
    "input": "#6c6e6c",
    "primary": "#54c57a",
    "primary-foreground": "#041107",
    "accent": "#1a3e26",
    "accent-foreground": "#cdefd5",
    "brand": "#102c19",
    "brand-foreground": "#edf4ee",
    "ring": "#4fa46a",
    "success": "#7fc76f",
    "warning": "#e6b55d",
    "destructive": "#f48780",
    "info": "#7db4e4",
    "link": "#54c57a",
  },
};

export const saadsRed: ThemeDefinition = {
  id: "saads-red",
  name: "Saads Red",
  light: {
    "background": "#ffffff",
    "foreground": "#262626",
    "card": "#ffffff",
    "muted": "#f4f4f4",
    "muted-foreground": "#525252",
    "border": "#e0e0e0",
    "input": "#929292",
    "primary": "#cc0000",
    "primary-foreground": "#ffffff",
    "accent": "#ffe6e6",
    "accent-foreground": "#990000",
    "brand": "#990000",
    "brand-foreground": "#ffffff",
    "ring": "#d62727",
    "success": "#2f7a1c",
    "warning": "#8a5a00",
    "destructive": "#b22534",
    "info": "#2563a8",
    "popover": "#ffffff",
    "link": "#cc0000",
  },
  dark: {
    "background": "#161616",
    "foreground": "#f0f0f0",
    "card": "#202020",
    "popover": "#2a2a2a",
    "muted": "#303030",
    "muted-foreground": "#b1b1b1",
    "border": "#414141",
    "input": "#6d6d6d",
    "primary": "#dd0000",
    "primary-foreground": "#ffffff",
    "link": "#ff7769",
    "accent": "#551914",
    "accent-foreground": "#ffd0c8",
    "brand": "#790000",
    "brand-foreground": "#f5f5f5",
    "ring": "#ec5448",
    "success": "#7fc76f",
    "warning": "#e6b55d",
    "destructive": "#f48780",
    "info": "#7db4e4",
  },
};

export const graphite: ThemeDefinition = {
  id: "graphite",
  name: "Graphite",
  light: {
    "background": "#fafafa",
    "foreground": "#181818",
    "card": "#ffffff",
    "muted": "#f0f0f0",
    "muted-foreground": "#636363",
    "border": "#e1e1e1",
    "input": "#8e8e8e",
    "primary": "#636363",
    "primary-foreground": "#ffffff",
    "accent": "#eeeeee",
    "accent-foreground": "#2e2e2e",
    "brand": "#383838",
    "brand-foreground": "#ffffff",
    "ring": "#808080",
    "success": "#3a732c",
    "warning": "#875814",
    "destructive": "#ac2f2f",
    "info": "#296898",
    "popover": "#ffffff",
    "link": "#636363",
  },
  dark: {
    "background": "#161616",
    "foreground": "#f0f0f0",
    "card": "#202020",
    "popover": "#2a2a2a",
    "muted": "#303030",
    "muted-foreground": "#b1b1b1",
    "border": "#414141",
    "input": "#6d6d6d",
    "primary": "#e8e8e8",
    "primary-foreground": "#161616",
    "link": "#d1d1d1",
    "accent": "#353535",
    "accent-foreground": "#e8e8e8",
    "brand": "#242424",
    "brand-foreground": "#f5f5f5",
    "ring": "#9e9e9e",
    "success": "#7fc76f",
    "warning": "#e6b55d",
    "destructive": "#f48780",
    "info": "#7db4e4",
  },
};

export const indigo: ThemeDefinition = {
  id: "indigo",
  name: "Indigo",
  light: {
    "background": "#f9fafd",
    "foreground": "#151822",
    "card": "#ffffff",
    "muted": "#edf0f8",
    "muted-foreground": "#5e6372",
    "border": "#dee1ea",
    "input": "#8c8e94",
    "primary": "#505f9a",
    "primary-foreground": "#ffffff",
    "accent": "#e7eeff",
    "accent-foreground": "#212a52",
    "brand": "#242f75",
    "brand-foreground": "#ffffff",
    "ring": "#6c7cba",
    "success": "#3a732c",
    "warning": "#875814",
    "destructive": "#ac2f2f",
    "info": "#296898",
    "popover": "#ffffff",
    "link": "#505f9a",
  },
  dark: {
    "background": "#151618",
    "foreground": "#eff0f3",
    "card": "#1f2023",
    "popover": "#282a2f",
    "muted": "#2f3035",
    "muted-foreground": "#afb1b6",
    "border": "#3e4148",
    "input": "#6c6d70",
    "primary": "#5163ff",
    "primary-foreground": "#ffffff",
    "link": "#9eb5ff",
    "accent": "#28325d",
    "accent-foreground": "#d7e3ff",
    "brand": "#18205e",
    "brand-foreground": "#f3f5fc",
    "ring": "#7c92e9",
    "success": "#7fc76f",
    "warning": "#e6b55d",
    "destructive": "#f48780",
    "info": "#7db4e4",
  },
};

export const purple: ThemeDefinition = {
  id: "purple",
  name: "Purple",
  light: {
    "background": "#eff3f6",
    "foreground": "#1c1f24",
    "card": "#ffffff",
    "muted": "#e4eaef",
    "muted-foreground": "#464646",
    "border": "#dddddd",
    "input": "#85898d",
    "primary": "#cc285a",
    "primary-foreground": "#ffffff",
    "accent": "#f6e3ef",
    "accent-foreground": "#6a004d",
    "brand": "#81005e",
    "brand-foreground": "#ffffff",
    "ring": "#cc285a",
    "success": "#2f7a1c",
    "warning": "#8a5a00",
    "destructive": "#b22534",
    "info": "#2563a8",
    "popover": "#ffffff",
    "link": "#c42656",
  },
  dark: {
    "background": "#171518",
    "foreground": "#f1eff2",
    "card": "#222022",
    "popover": "#2c292d",
    "muted": "#322f33",
    "muted-foreground": "#b3b0b4",
    "border": "#443f46",
    "input": "#6e6c6f",
    "primary": "#aa4ccb",
    "primary-foreground": "#ffffff",
    "link": "#d6a5ea",
    "accent": "#43294d",
    "accent-foreground": "#f2dbfc",
    "brand": "#3b1449",
    "brand-foreground": "#f8f3fa",
    "ring": "#b580ca",
    "success": "#7fc76f",
    "warning": "#e6b55d",
    "destructive": "#f48780",
    "info": "#7db4e4",
  },
};

export const slate: ThemeDefinition = {
  id: "slate",
  name: "Slate",
  light: {
    "background": "#f8fafd",
    "foreground": "#121921",
    "card": "#ffffff",
    "muted": "#ecf1f7",
    "muted-foreground": "#5a6472",
    "border": "#dde2e8",
    "input": "#8a8e93",
    "primary": "#566578",
    "primary-foreground": "#ffffff",
    "accent": "#eaeff6",
    "accent-foreground": "#252f3b",
    "brand": "#28394f",
    "brand-foreground": "#ffffff",
    "ring": "#728296",
    "success": "#3a732c",
    "warning": "#875814",
    "destructive": "#ac2f2f",
    "info": "#296898",
    "popover": "#ffffff",
    "link": "#566578",
  },
  dark: {
    "background": "#151618",
    "foreground": "#eef0f3",
    "card": "#1f2123",
    "popover": "#272a2f",
    "muted": "#2d3135",
    "muted-foreground": "#aeb1b6",
    "border": "#3c4248",
    "input": "#6c6d70",
    "primary": "#4f76a8",
    "primary-foreground": "#ffffff",
    "link": "#a6bddb",
    "accent": "#2a3646",
    "accent-foreground": "#dbe6f4",
    "brand": "#192a3f",
    "brand-foreground": "#f1f6fc",
    "ring": "#829aba",
    "success": "#7fc76f",
    "warning": "#e6b55d",
    "destructive": "#f48780",
    "info": "#7db4e4",
  },
};
